"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var IdleOnConnect = true;
var IdleInfo = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    z-index: 10;\n    position: absolute;\n    width: 100%;\n    height:100%;\n    background-color: transparent;\n    pointer-events: none;\n"], ["\n    z-index: 10;\n    position: absolute;\n    width: 100%;\n    height:100%;\n    background-color: transparent;\n    pointer-events: none;\n"])));
var IdleImg = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    transition: opacity 0.5s ease-in-out;\n    opacity: ", ";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 120px;\n    height: 120px;\n    @media ", "{\n        width: 84px;\n        height: 84px;\n    }\n    transform: translate(-50%, -50%);\n    border-radius: 8px;\n\n    ", ";\n"], ["\n    transition: opacity 0.5s ease-in-out;\n    opacity: ", ";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 120px;\n    height: 120px;\n    @media ", "{\n        width: 84px;\n        height: 84px;\n    }\n    transform: translate(-50%, -50%);\n    border-radius: 8px;\n\n    ", ";\n"])), function (props) { return props.show ? "0.75" : "0"; }, function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.layout.idleIndicator; });
var IdleIndicator = /** @class */ (function (_super) {
    __extends(IdleIndicator, _super);
    function IdleIndicator(props) {
        var _this = _super.call(this, props) || this;
        _this.register = function () {
            var _a, _b, _c, _d, _e, _f;
            (_a = _this.props.zlbolt) === null || _a === void 0 ? void 0 : _a.addEventListener('modeChange', _this.onChangeMode);
            (_b = _this.props.zlbolt) === null || _b === void 0 ? void 0 : _b.addEventListener('onStreamDisconnect', _this.hide);
            (_c = _this.props.zlbolt) === null || _c === void 0 ? void 0 : _c.addEventListener('streamBecameActive', _this.hide);
            (_d = _this.props.zlbolt) === null || _d === void 0 ? void 0 : _d.addEventListener('streamBecameIdle', _this.show);
            if (IdleOnConnect) {
                (_e = _this.props.zlbolt) === null || _e === void 0 ? void 0 : _e.addEventListener('streamReady', _this.show);
                (_f = _this.props.zlbolt) === null || _f === void 0 ? void 0 : _f.addEventListener('cameraMoving', _this.hide);
            }
        };
        _this.unregister = function (zlbolt) {
            zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener('modeChange', _this.onChangeMode);
            zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener('onStreamDisconnect', _this.hide);
            zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener('streamBecameActive', _this.hide);
            zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener('streamBecameIdle', _this.show);
            if (IdleOnConnect) {
                zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener('streamReady', _this.show);
                zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener('cameraMoving', _this.hide);
            }
        };
        _this.show = function () {
            _this.setState(function (prevState) { return ({
                showMe: true,
                showCounter: prevState.showCounter + (prevState.showMe ? 0 : 1),
                twoD: _this.props.zlbolt.getCurrentMode() === "2D"
            }); });
        };
        _this.hide = function () {
            _this.setState({ showMe: false });
        };
        _this.onChangeMode = function (mode) {
            if (mode === "2D") {
                _this.setState({ showMe: false, showCounter: 0 });
            }
        };
        _this.state = {
            showMe: false,
            twoD: false,
            showCounter: 0
        };
        return _this;
    }
    IdleIndicator.prototype.componentDidMount = function () {
        this.register();
    };
    IdleIndicator.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.zlbolt !== this.props.zlbolt) {
            if (prevProps.zlbolt) {
                this.unregister(prevProps.zlbolt);
            }
            if (this.props.zlbolt) {
                this.register();
            }
        }
    };
    IdleIndicator.prototype.componentWillUnmount = function () {
        this.unregister(this.props.zlbolt);
    };
    IdleIndicator.prototype.render = function () {
        return (react_1.default.createElement(IdleInfo, null,
            react_1.default.createElement(IdleImg, { isLinearWithSamples: this.props.isLinearWithSamples, show: this.state.showMe && this.state.showCounter === 1, src: this.state.twoD ? this.props.theme.icons.cue2d : this.props.theme.icons.cue3d, alt: "interactive scene" })));
    };
    return IdleIndicator;
}(react_1.Component));
exports.default = styled_components_1.withTheme(IdleIndicator);
var templateObject_1, templateObject_2;
//# sourceMappingURL=IdleIndicator.js.map